const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));

    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

const MAX_OUTPUT_SIZE = 1600;

export async function getCroppedImageBlob(
  imageSrc,
  pixelCrop,
  maxOutputSize = MAX_OUTPUT_SIZE
) {
  const image = await createImage(imageSrc);

  const cropWidth = Math.round(pixelCrop.width);
  const cropHeight = Math.round(pixelCrop.height);

  // Square crop uses the smaller crop dimension.
  const cropSize = Math.min(cropWidth, cropHeight);

  // Never upscale the original image.
  const outputSize = Math.min(cropSize, maxOutputSize);

  const canvas = document.createElement("canvas");

  canvas.width = outputSize;
  canvas.height = outputSize;

  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Could not create canvas context");
  }

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    cropSize,
    cropSize,
    0,
    0,
    outputSize,
    outputSize
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Could not process the selected image"));
          return;
        }

        resolve(blob);
      },
      "image/jpeg",
      0.95
    );
  });
}